<template>
  <div @change="validateSection">
    <header>
      <h3>Gyne Procedures</h3>
    </header>

    <div class="content">
      <div class="form__row--x" v-if="!isClose">
        <label>Procedures</label>
        <smd-select v-model="procedureModel"
                    :hide-tags="true"
                    :hide-selected="true"
                    :options="mutiSelectLookup"
                    @open="onSelectOpen"
                    @search-change="onSearchChange"/>
      </div>

      <template v-if="showHistory">
        <div class="data-entry-3" >
          <label>Category</label>
          <label>Procedure</label>
          <label></label>
        </div>

        <div class="data-entry-3" v-for="(value, key) in concomitantProcedure" :key="key">
          <p><strong>{{ value.categoryId | decodeProcedureCategory }}</strong></p>
          <p>{{ key | decodeProcedureConditions }}</p>
          <p>
            <!-- Removed procedure Type
            <select v-model="value.procedureType"
                    :disabled="isClose">
              <option v-for="choice in $options.procedureTypes(value.categoryId)()"
                      :value="choice.id"
                      :key="choice.id">
                {{ choice.name }}
              </option>
            </select>
            --->
          </p>

          <smd-btn icon="smd-icon-action-delete"
                   @click="removeMultiSelectItem(key)"
                   v-if="!isClose"/>
        </div>
      </template>

      <!--- Removed version 7
      <div class="form__row--x" :style="highlightIfError('hasFailedMIS')">
        <label>Has Patient Undergone a failed MIS Procedure during this time?</label>
        <smd-segment type="pill"
                     v-model="hasFailedMIS"
                     :items="$options.booleanChoices"
                     :disabled="isClose"/>
      </div>
      --->
    </div>

  </div>
</template>

<script>
  import validations from '../../../validations/procedures-section-validation'
  import withSectionValidation from '../../../mixins/with-section-validation'
  import withErrorValidation from '../../../mixins/with-error-validation-mixin';
  import caseFormMultiSelectMixin from './case-form-section-with-multiselect'
  import {reduceModelFromKeys} from '../../../utilities/reduceFunctions';
  import {mapActions} from 'vuex'
  import {createHelpers} from 'vuex-map-fields'
  import {
    REF_MATERNAL_FETAL_FORM_ORGAN,
    REF_MATERNAL_FETAL_FORM_ORGAN_PROCEDURES_OBJ,
    REF_PROCEDURE_TYPES,
    REF_PROCEDURE_TYPES_MIS,
    REF_PROCEDURE_TYPES_OTHERS,
    REF_PROCEDURE_TYPES_UTERUS,
    getMapFn
  } from "../../../store/modules/referencedata2";
  import {
    GETTER_CASE_FORM_STATE_FIELD,
    SETTER_CASE_FORM_STATE_FIELD,
    ACTION_UPDATE_CONCOMITTANT
  } from '../../../store/forms/case-form-state'

  const {mapFields} = createHelpers({
    getterType: GETTER_CASE_FORM_STATE_FIELD,
    mutationType: SETTER_CASE_FORM_STATE_FIELD
  });

  export default {
    mixins: [caseFormMultiSelectMixin, withSectionValidation, withErrorValidation],
    computed: {
      ...mapFields([
        'isMedical',
        'isSurgical',
        'isChemotherapy',
        'isRadiotherapy',
        'isOthers',
        'otherProcedure',
        'concomitantProcedure',
        'isClose',
        'hasFailedMIS'
      ]),
      showHistory() {
        return !!Object.keys(this.concomitantProcedure).length;
      },
      procedureModel: {
        get() {
          return this.generateMultiSelectModel();
        },
        set(v) {
          const defaultFunc = (elem) => {
            if (elem["categoryId"] === 1) {
              return {procedureType: 1};
            } else if (elem["categoryId"] === 7) {
              return {procedureType: 4};
            } else if (elem["categoryId"] === 8) {
              return {procedureType: 5};
            } else {
              return {procedureType: 1};
            }
          };
          console.log("Multi-select: " + JSON.stringify(v));
          const model = v.reduce(reduceModelFromKeys(defaultFunc)(this.concomitantProcedure),[]);
          this.doUpdateMultiSelectModel(model);
        }
      }
    },
    methods: {
      ...mapActions({
        doUpdateMultiSelectModel: ACTION_UPDATE_CONCOMITTANT
      }),
      getRawModelForMultiSelect() {
        return this.concomitantProcedure;
      },
      onSelectOpen() {
        this.$emit('add');
      },
      onSearchChange(q) {
        this.$emit('search-change', q);
      }
    },
    procedureTypes: function(categoryId) {
      if (categoryId === 1) {
        return getMapFn(REF_PROCEDURE_TYPES_UTERUS);
      } else if (categoryId === 7) {
        // MIS Procedures
        return getMapFn(REF_PROCEDURE_TYPES_MIS);
      } else if (categoryId === 8) {
        // Other Procedures
        return getMapFn(REF_PROCEDURE_TYPES_OTHERS);
      } else {
        // Everything else
        return getMapFn(REF_PROCEDURE_TYPES);
      }
    },
    validationSection: 'procedures',
    multiSelectLookupName: REF_MATERNAL_FETAL_FORM_ORGAN,
    multiSelectConditionsLookupName: REF_MATERNAL_FETAL_FORM_ORGAN_PROCEDURES_OBJ,
    multiSelectFormSection: 'concomitantProcedure',
    booleanChoices: [
      {id: 1, name: 'YES', val: true},
      {id: 2, name: 'NO', val: false}
    ],
    validations
  }
</script>

<style lang="scss" scoped>
  @import "../../../scaffolding/scss/pogs-util";

  .data-entry-3 {
  @include responsive(mobile) {
    grid-template-columns: 55px 85px 1fr auto;
  }
    p:nth-child(2) {
      word-break: break-word;
    }
  select {
    width: 100%;
    min-width: 80px;
  }
  }
</style>
